import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const SURVEY_LIST = 'survey list'
export const SURVEY_NAME = 'survey name'
export const CHANGE_SURVEY_OWNER = 'Change Survey Owner'
export const NO_USER = 'no user'

export default {
  [PORTUGUESE]: {
    [SURVEY_LIST]: 'Lista de Pesquisas',
    [SURVEY_NAME]: 'Nome da Pesquisa',
    [CHANGE_SURVEY_OWNER]: 'Alterar Proprietário da Pesquisa',
    [NO_USER]: 'Não há informações sobre este usuário',
  },

  [ENGLISH]: {
    [SURVEY_LIST]: 'Survey List',
    [SURVEY_NAME]: 'Survey Name',
    [CHANGE_SURVEY_OWNER]: 'Change Survey Owner',
    [NO_USER]: 'There is no information about this user',
  },

  [SPANISH]: {
    [SURVEY_LIST]: 'Lista de Encuestas',
    [SURVEY_NAME]: 'Nombre de la Encuesta',
    [CHANGE_SURVEY_OWNER]: 'Cambiar Propietario de la Encuesta',
    [NO_USER]: 'No hay información sobre este usuario',
  },
}
